export enum InsuranceRangeTypeEnum {
  EURO = 'EURO',
  PERCENTAGE = 'PERCENTAGE',
}
